import { render, staticRenderFns } from "./Scada.vue?vue&type=template&id=8935ef42&"
import script from "./Scada.vue?vue&type=script&lang=js&"
export * from "./Scada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports